import Vue from 'vue'
import VueRouter from 'vue-router'

import WordInfo from '../pages/WordInfo.vue'
import BookWord from '../pages/BookWord.vue'
import PictureWord from '../pages/PictureWord.vue'
import VideoWord from '../pages/VideoWord.vue'
import PersonInfo from '../pages/PersonInfo.vue'
import Login from '../pages/Login.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/wordinfo' },
  { path: '/wordinfo', name: 'WordInfo', component: WordInfo, meta: { title: '单词本' } },
  { path: '/bookword', name: 'BookWord', component: BookWord, meta: { title: '课本单词' } },
  { path: '/pictureword', name: 'PictureWord', component: PictureWord, meta: { title: '看图记词' } },
  { path: '/videoword', name: 'VideoWord', component: VideoWord, meta: { title: '视频频学' } },
  { path: '/personinfo', name: 'PersonInfo', component: PersonInfo, meta: { title: '个人中心' } },
  { path: '/login', name: 'Login', component: Login, meta: { title: '登录' } }
]

const router = new VueRouter({
  routes
})

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + ' - 搜搜单词'
  }
})

export default router
